import { useFormikContext } from "formik"
import { AgreementOptions, EntityHistory } from "../../../../../support/admin/entities/supportEntitiesTypes"
import { AccountFromValues } from "../accountTypes"
import { FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { AddressContent } from "../../../../../support/admin/entities/components/form/AddressContent"
import { ContactDetailsContent } from "../../../../../support/admin/entities/components/form/ContactDetailsContent"
import { EntityHistoryAccordion } from "../../../../../support/admin/entities/components/EntityHistoryAccordion"
import { InvoiceDetailsContent } from "../../../../../support/admin/entities/components/form/InvoiceDetailsContent"
import { EntityTypeSelect } from "../../../../../support/admin/entities/components/form/EntityTypeSelect"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { SupplierFormValues } from "../../../../../support/admin/entities/supplier/supplierTypes"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"

export function AccountUpdateContent({ history }: { history?: EntityHistory }) {
    const { values } = useFormikContext<AccountFromValues>()

    return (
        <StandardForm>
            <StandardMainPanel>
                <EntityTypeSelect />
                <LocalizedStrict id="supplier-update-account-registration-number-label" attrs={{ label: true }}>
                    <FormikTextField<AccountFromValues>
                        name="businessNumber"
                        label="Registration number"
                        sx={{ width: "18rem" }}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="support-create-supplier-company-name-label" attrs={{ label: true }}>
                    <FormikTextField<AccountFromValues> name="name" label="Company name" fullWidth />
                </LocalizedStrict>
                <AddressContent />
            </StandardMainPanel>
            <StandardMainPanel>
                <ContactDetailsContent />
            </StandardMainPanel>
            {values.isSystemOwner === AgreementOptions.YES && (
                <StandardMainPanel>
                    <InvoiceDetailsContent />
                </StandardMainPanel>
            )}
            <LocalizedStrict id="support-create-supplier-aside-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="support-create-supplier-aside-active">
                        <FormikSwitch<SupplierFormValues> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
            {history && (
                <LocalizedStrict id="support-create-entity-aside-history" attrs={{ title: true }}>
                    <StandardSidePanel variant="collapsible" title="History">
                        <EntityHistoryAccordion history={history} />
                    </StandardSidePanel>
                </LocalizedStrict>
            )}
        </StandardForm>
    )
}
